import {FETCH_TAG, PATCH_TAG, PATCH_TAG_FAIL, POST_TAG, POST_TAG_FAIL} from "../actionTypes";

const initialState = {
    id: 0,
    name: "",
    color: "",
    category: "",
    status: 0,
    message: ""
}

const tagReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TAG :
            return {
                ...state,
                id: action.payload.id,
                name: action.payload.name,
                color: action.payload.color,
                category: action.payload.category,
            }
        case POST_TAG || PATCH_TAG:
            return {
                ...state,
                message: action.payload.message,
                status: action.payload.status
            }
        case  PATCH_TAG:
            return {
                ...state,
                message: action.payload.message,
                status: action.payload.status
            }

        case POST_TAG_FAIL || PATCH_TAG_FAIL :
            return {
                ...state,
                message: action.payload.message,
                status: action.payload.status
            }
        default:
            return {
                ...state
            }
    }
}

export default tagReducer;